/** Palette ECharts / graphiques — charte 17.45 (thème clair). */
export const JS_THEME_BASE_VARIABLES = {
	primary: '#E43726',
	primaryLight: '#ED84B1',
	success: '#43AC48',
	successLight: '#60C95C',
	warning: '#FFD445',
	warningLight: '#FFE56B',
	bg: '#ffffff',
	bg2: '#FDEBDB',
	bg3: '#F5DCC8',
	bg4: '#FEFAF6',
	fg: '#756258',
	fgText: '#4B2B2B',
	fgHighlight: '#E43726',
	border2: '#F5DCC8',
	border3: '#E8C9B0',
	border4: '#C9A892',
	border5: '#9A8476',
	separator: '#F5DCC8',
};

export const JS_THEME_DARK_VARIABLES = {
	...JS_THEME_BASE_VARIABLES,
	bg: '#1A0F0F',
	bg2: '#2A1818',
	bg3: '#3A2121',
	bg4: '#4B2B2B',
	fg: '#FDEBDB',
	fgText: '#F5DCC8',
	border2: '#3A2121',
	border3: '#4B2B2B',
	border4: '#756258',
	separator: '#3A2121',
};
